import { kea } from 'kea'
import { put } from 'redux-saga/effects'
import PropTypes from 'prop-types'

const logic = kea({
  path: () => ['scenes', 'popupsPhone', 'index'],

  actions: () => ({
    selectRequest: true,
    selectContact: true,
    submit: true,
    setSubmitting: true
  }),

  reducers: ({ actions }) => ({
    selection: [
      '',
      PropTypes.string,
      {
        [actions.selectRequest]: () => 'request',
        [actions.selectContact]: () => 'contact'
      }
    ],

    isSubmitting: [
      false,
      PropTypes.bool,
      {
        [actions.setSubmitting]: () => true
      }
    ]
  }),

  takeLatest: ({ actions }) => ({
    [actions.submit]: function * () {
      const { selection } = yield this.get()
      const { setSubmitting } = this.actions

      let url

      if (selection === 'request') {
        url = '/looking-for-a-teacher'
      } else if (selection === 'contact') {
        url = '/help'
      }

      if (url) {
        yield put(setSubmitting())
        if (window.parent) {
          window.parent.location.href = url
        } else {
          window.location.href = url
        }
      }
    }
  })
})

export default logic
